module.exports = __webpack_public_path__ + "img/tax04.87ee1cac.png";